import { Fragment, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Item, WithTooltip } from 'basic-components';
import { globalActions } from 'primary-components';

import { creatorSeriesActions } from 'actions/series';

import SymbolModal from 'primary/SymbolModal';

import { Else, If, Then, When } from 'react-if';

const PatternItem = ({ isStartingResults, selectedItems }) => {
  const dispatch = useDispatch(),
        [isModalOpen, setIsModalOpen] = useState(false),
        query = useSelector(state => state.seriesState.creatorState.query),
        filters = useSelector(state => state.seriesState.creatorState.filters),
        userDefinedFilters = useSelector(state => state.seriesState.creatorState.userDefinedFilters),
        areSingleItemsSelected = useMemo(() => selectedItems.some(s => s.pattern === "false"), [selectedItems]),
        createPattern = useCallback(source => {
          dispatch(creatorSeriesActions.createPattern(source))
          dispatch(globalActions.getMessageStore()).success("Matching data added to the basket.")
        }, [dispatch]),
        openModal = useCallback(() => setIsModalOpen(true), []),
        openModalWithToast = useCallback(() => {
          dispatch(globalActions.getToastsStore()).warning("To create a pattern you need to discard all your data selections. Do you want to proceed?", "Create pattern", {
              withCancel: false,
              confirmText: "Confirm",
              confirmAction: () => {
                dispatch(creatorSeriesActions.onChange(selectedItems.filter(i => i.pattern === "true"), "selectedSymbols"))
                openModal()
              }
            })
        }, [dispatch, openModal, selectedItems]),
        onClose = useCallback(() => setIsModalOpen(false), []),
        symbols = useMemo(() => creatorSeriesActions.getSymbolsFilter({ filters, userDefinedFilters }), [filters, userDefinedFilters]),
        metadata = useMemo(() => creatorSeriesActions.getMetadatasFilter({ filters, userDefinedFilters }), [filters, userDefinedFilters]),
        groupName = useMemo(() => creatorSeriesActions.getGroupFilter({ filters, userDefinedFilters }), [filters, userDefinedFilters]),
        symbol = useMemo(() => ({ query, symbols, metadata, groupName, pattern: "true" }), [groupName, metadata, query, symbols])

  return (
    <Fragment>
      <If condition={isStartingResults}>
        <Then>
          {() => (
            <WithTooltip
                data-place="bottom"
                text="Select filters to create a pattern"
            >
              <Item
                  disabled={isStartingResults}
                  onClick={areSingleItemsSelected ? openModalWithToast : openModal}
              >
                Create pattern
              </Item>
            </WithTooltip>
          )}
        </Then>
        <Else>
          {() => (
            <Item 
                disabled={isStartingResults}
                onClick={areSingleItemsSelected ? openModalWithToast : openModal}
            >
              Create pattern
            </Item>
          )}
        </Else>
      </If>
      <When condition={isModalOpen}>
          <SymbolModal
              onClose={onClose}
              onSubmit={createPattern}
              optionalText={"Create pattern"}
              symbol={symbol}
              withSourceSelect
          />
      </When>
    </Fragment>
  )
}

PatternItem.propTypes ={
  isStartingResults: PropTypes.bool.isRequired,
  selectedItems: PropTypes.array.isRequired,
}

export default PatternItem;